


































































































import { Component, Vue } from 'vue-property-decorator';

import util from '../lib/util';
import dataLanguages from '@/data/languages';
import { ILanguage } from '@/store/entities/ILanguage';
import currencies from '@/data/currencies';
@Component
export default class HeaderHome extends Vue {
  scrollPosition = null;
  currency = currencies;
  selectedCurrency: string = this.$store.state.currency.id;
  selectedLanguage: any = {};
  languages = dataLanguages;
  shouldHideCurrencySelector: boolean = false;

  created() {
    this.$store.dispatch({
      type: 'currency/init',
    });
    this.selectedLanguage = this.languages.find(
      (t) => t.locale === localStorage.lang
    );
    this.selectedCurrency = this.$store.state.currency.id;
    
    // URL'deki marker parametresini kontrol et (hem ana URL'de hem de hash kısmında)
    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;
    const hashParts = hash.split('?');
    const hashParams = hashParts.length > 1 ? new URLSearchParams(hashParts[1]) : new URLSearchParams();
    
    // Her iki yerde de marker parametresini kontrol et
    const hasMarker = urlParams.has('marker') || hashParams.has('marker');
    const isCurrencyRub = this.selectedCurrency === 'RUB';
    
    // Eğer marker parametresi varsa ve para birimi RUB ise para birimi değiştirme seçeneğini gizle
    this.shouldHideCurrencySelector = hasMarker && isCurrencyRub;
  }

  handleSelectedCurrency(e: any) {
    localStorage.currency = e.target.textContent;
    this.$store.dispatch({
      type: 'currency/getCurrency',
      data: e.target.textContent,
    });
    this.selectedCurrency = this.$store.state.currency.id;
       var toogle =   this.$refs.toggler as any;
    toogle.click();
  }
  handleLanguage(language: any) {
   
    const matchedLanguage = this.languages.find(
      (lang) => lang.locale === language.locale
    );
    this.selectedLanguage = matchedLanguage;
    localStorage.lang = matchedLanguage.locale;
    this.$i18n.locale = matchedLanguage.locale;
    
    var toogle =   this.$refs.toggler as any;
    toogle.click();
  }

  updateScroll() {
    this.scrollPosition = window.scrollY;
  }

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  }
}
